(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-about-review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-reviews')) {
  customElements.define('sf-reviews', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      this.link = this.querySelector('[data-review-link]');
      this.pauseButton = this.querySelector('[data-pause]');
      this.current = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.inView = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const manual = index => { this.paused = true; this.show(index, true); this.updatePause(); this.schedule(); };
      this.querySelector('[data-previous]')?.addEventListener('click', () => manual(this.current - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => manual(this.current + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => manual(index), options));
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); manual(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); }, { threshold: .25 });
      this.observer.observe(this);
      this.editHandler = event => { const index = this.slides.findIndex(slide => slide.contains(event.target) || slide === event.target); if (index >= 0) manual(index); };
      document.addEventListener('shopify:block:select', this.editHandler, options);
      this.updatePause();
    }
    show(index, announce = false) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        this.dots[position]?.setAttribute('aria-current', String(active));
      });
      const active = this.slides[this.current];
      if (this.link) this.link.href = active.dataset.sourceUrl;
      if (announce) this.querySelector('[data-announcement]').textContent = active.getAttribute('aria-label') + ': ' + active.querySelector('.sf-reviews__author').textContent;
    }
    updatePause() {
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || !this.inView || document.hidden || this.contains(document.activeElement) || this.slides.length < 2) return;
      this.timer = setTimeout(() => { this.show(this.current + 1); this.schedule(); }, 9000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-collection-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-collection-card-media')) {
  customElements.define('sf-collection-card-media', class extends HTMLElement {
    connectedCallback() {
      if (this.image) return;
      this.image = this.querySelector('img');
      if (!this.image) {
        this.showPlaceholder();
        return;
      }
      this.attempts = 0;
      this.image.addEventListener('error', () => this.recover());
      if (this.image.complete && this.image.naturalWidth === 0) this.recover();
    }
    showPlaceholder() {
      if (this.image) this.image.hidden = true;
      const placeholder = this.querySelector('[data-card-placeholder]');
      if (placeholder) placeholder.hidden = false;
    }
    recover() {
      const image = this.image;
      if (this.attempts === 0) {
        this.attempts = 1;
        const retry = new URL(image.src, location.href);
        retry.searchParams.set('sf_image_retry', '1');
        image.removeAttribute('srcset');
        image.src = retry.href;
      } else if (this.attempts === 1 && this.dataset.fallback) {
        this.attempts = 2;
        image.src = this.dataset.fallback;
      } else {
        this.showPlaceholder();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-collection-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-collection-page')) {
  customElements.define('sf-collection-page', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const parts = location.pathname.split('/');
      this.collectionPath = parts.slice(0, parts.indexOf('collections') + 2).join('/');
      this.desktop = this.querySelector('[data-filter-slot]');
      this.filters = this.querySelector('[data-filter-content]');
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-filter-open]');
      this.breakpoint = matchMedia('(max-width: 1099px)');
      this.addEventListener('click', event => {
        if (event.target.closest('[data-filter-open]') && this.dialog) {
          this.previousOverflow = document.body.style.overflow;
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
          this.dialog.querySelector('[data-filter-close]')?.focus();
          return;
        }
        if (event.target.closest('[data-filter-close]')) {
          this.dialog?.close();
          return;
        }
        const link = event.target.closest('.sf-collection-pagination a, .sf-collection-filter-option[href], .sf-collection-filter-clear, .sf-collection-clear-all, .sf-collection-chip[href], .sf-collection-empty a');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
        const url = new URL(link.href);
        if (!this.isCollectionUrl(url)) return;
        event.preventDefault();
        const pagination = link.closest('.sf-collection-pagination');
        if (!pagination) url.searchParams.delete('page');
        this.loadPage(url, true);
      }, { signal });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-sort]')) return;
        const url = new URL(location.href);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        url.hash = 'CollectionListings-' + this.dataset.sectionId;
        this.loadPage(url, true);
      }, { signal });
      window.addEventListener('popstate', () => {
        const url = new URL(location.href);
        if (this.isCollectionUrl(url)) this.loadPage(url, false);
      }, { signal });
      this.prepareTagLinks();
      this.addEventListener('keydown', event => {
        const link = event.target.closest('a[role="checkbox"],a[role="radio"]');
        if (link && event.key === ' ') { event.preventDefault(); link.click(); }
      }, { signal });
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-collection-search]');
        if (!form) return;
        const tag = form.dataset.searchTag;
        if (!tag) return;
        event.preventDefault();
        const input = form.querySelector('[name="q"]').value.trim();
        if (!input) return;
        const quoted = value => '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
        const query = 'tag:' + quoted(tag) + ' AND ' + input.split(/\s+/).map(quoted).join(' AND ');
        const url = new URL(form.action);
        url.search = new URLSearchParams(new FormData(form)).toString();
        url.searchParams.set('q', query);
        location.assign(url.href);
      }, { signal });
      if (this.desktop && this.filters && this.dialog && this.trigger) {
        this.moveFilters = () => {
          if (this.dialog.open) this.dialog.close();
          (this.breakpoint.matches ? this.dialog.querySelector('[data-filter-host]') : this.desktop).append(this.filters);
        };
        this.moveFilters();
        this.breakpoint.addEventListener('change', this.moveFilters, { signal });
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow || '';
          this.trigger?.setAttribute('aria-expanded', 'false');
          if (this.breakpoint.matches) this.trigger?.focus();
        }, { signal });
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, { signal });
      }
      this.setAttribute('data-enhanced', '');
    }
    isCollectionUrl(url) {
      return url.origin === location.origin && (url.pathname === this.collectionPath || url.pathname.startsWith(this.collectionPath + '/'));
    }
    prepareTagLinks() {
      this.querySelectorAll('[data-tag-link]').forEach(link => {
        const url = new URL(link.href);
        url.search = location.search;
        url.searchParams.delete('page');
        link.href = url.href;
      });
    }
    scrollToListings() {
      const listings = this.querySelector('.sf-collection-layout');
      if (listings) window.scrollTo({ top: Math.max(0, window.scrollY + listings.getBoundingClientRect().top), behavior: 'instant' });
    }
    async loadPage(url, updateHistory) {
      const results = this.querySelector('.sf-collection-results');
      if (!results || !this.dataset.sectionId) { location.assign(url.href); return; }
      this.pageRequest?.abort();
      const request = new AbortController();
      this.pageRequest = request;
      results.setAttribute('aria-busy', 'true');
      const currentUrl = new URL(location.href);
      for (const key of ['preview_theme_id', 'view']) {
        if (!url.searchParams.has(key) && currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
      }
      const requestUrl = new URL(url.href);
      requestUrl.hash = '';
      requestUrl.searchParams.set('sections', this.dataset.sectionId);
      try {
        const response = await fetch(requestUrl.href, { signal: request.signal });
        if (!response.ok) throw new Error('Collection request failed');
        const sections = await response.json();
        const html = sections[this.dataset.sectionId];
        if (!html) throw new Error('Collection section missing');
        const page = new DOMParser().parseFromString(html, 'text/html');
        const renderedResults = page.querySelector('.sf-collection-results');
        const renderedFilters = page.querySelector('[data-filter-content]');
        if (!renderedResults || !renderedFilters) throw new Error('Collection results missing');
        const nextResults = document.importNode(renderedResults, true);
        const nextFilters = document.importNode(renderedFilters, true);
        const filterStates = new Map(Array.from(this.filters.querySelectorAll('details')).map(group => [group.querySelector('summary')?.textContent.trim(), group.open]));
        nextFilters.querySelectorAll('details').forEach(group => {
          const key = group.querySelector('summary')?.textContent.trim();
          if (filterStates.has(key)) group.open = filterStates.get(key);
        });
        const search = this.filters.querySelector('[name="q"]');
        if (search) nextFilters.querySelector('[name="q"]').value = search.value;
        await Promise.allSettled(Array.from(nextResults.querySelectorAll('.sf-collection-grid img')).slice(0, 4).map(image => image.decode()));
        if (request.signal.aborted || !this.isConnected) return;
        if (updateHistory) history.pushState(history.state, '', url.href);
        this.filters.replaceWith(nextFilters);
        this.filters = nextFilters;
        results.replaceWith(nextResults);
        this.trigger = this.querySelector('[data-filter-open]');
        this.prepareTagLinks();
        if (this.dialog?.open) this.dialog.close();
        this.scrollToListings();
        const status = nextResults.querySelector('[role="status"]');
        if (status) { status.setAttribute('tabindex', '-1'); status.focus({ preventScroll: true }); }
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) location.assign(url.href);
      } finally {
        if (this.pageRequest === request) {
          this.querySelector('.sf-collection-results')?.removeAttribute('aria-busy');
          this.pageRequest = null;
        }
      }
    }
    disconnectedCallback() {
      this.pageRequest?.abort();
      if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow || ''; }
      this.controller?.abort();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-live-lock-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-live-lock')) {
  customElements.define('sf-live-lock', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      this.approved = new WeakSet();
      this.productApprovals = new WeakMap();
      this.busy = new WeakSet();
      this.clockBase = performance.now();
      this.state = JSON.parse(this.querySelector('[data-sf-live-lock-state]').textContent);
      this.serverBase = this.state.serverNow * 1000;
      this.renderedLock = !!document.querySelector('#MainContent [data-sf-release-screen]');
      this.cartBlocked = this.active() && this.state.coralKeys.length > 0;
      const signal = this.abort.signal;
      document.addEventListener('submit', event => this.guardSubmit(event), {capture:true, signal});
      document.addEventListener('click', event => this.guardClick(event), {capture:true, signal});
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) this.refresh().catch(() => {});
      }, {signal});
      window.addEventListener('pageshow', () => this.refresh().catch(() => {}), {signal});
      document.addEventListener('cart:update', () => this.refresh().catch(() => {}), {signal});
      document.addEventListener('cart:add', () => this.refresh().catch(() => {}), {signal});
      this.tick();
      this.clock = setInterval(() => this.tick(), 250);
      this.poll = setInterval(() => {
        if (!document.hidden) this.refresh().catch(() => {});
      }, 5000);
      this.refresh().catch(() => {});
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearInterval(this.clock);
      clearInterval(this.poll);
      this.clock = this.poll = null;
      this.inflight = null;
      this.checkoutStatusPending = null;
      this.refreshVersion = (this.refreshVersion || 0) + 1;
    }
    now() { return this.serverBase + performance.now() - this.clockBase; }
    active() {
      if (this.state.releaseAt > 0) return this.now() < this.state.releaseAt * 1000;
      return this.state.mode === 'manual';
    }
    async refresh(fresh = false) {
      // Purchase checks use the live service; rendered sections may carry a cached clock.
      if (fresh && this.dataset.lockApi) return this.refreshCheckoutStatus();
      if (this.checkoutStatusPending) return this.checkoutStatusPending;
      if (fresh && this.inflight) await this.inflight;
      if (this.inflight) return this.inflight;
      const version = this.refreshVersion = (this.refreshVersion || 0) + 1;
      const run = async () => {
        const url = new URL(this.dataset.root, location.origin);
        url.searchParams.set('section_id', 'sf-live-lock-status');
        url.searchParams.set('_sf_status', String(Date.now()));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:AbortSignal.any([this.abort.signal, AbortSignal.timeout(8000)])});
        if (!response.ok) throw Object.assign(new Error('Status unavailable'), {code:'STATUS_HTTP_' + response.status});
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = doc.querySelector('[data-sf-live-lock-state]');
        if (!data) throw Object.assign(new Error('Status missing'), {code:'STATUS_MISSING'});
        const next = JSON.parse(data.textContent);
        if (!['open','manual','scheduled'].includes(next.mode) || !Array.isArray(next.coralKeys)) throw Object.assign(new Error('Invalid status'), {code:'STATUS_INVALID'});
        let serverDate = Date.parse(response.headers.get('Date') || '');
        if (fresh && this.dataset.lockApi) {
          const signal = AbortSignal.any([this.abort.signal, AbortSignal.timeout(20000)]);
          const [lockResponse, cartResponse] = await Promise.all([
            fetch(new URL('/lock', this.dataset.lockApi), {credentials:'omit', cache:'no-store', signal}),
            fetch(new URL(this.dataset.cartUrl + '.js', location.origin), {credentials:'same-origin', cache:'no-store', signal})
          ]);
          if (!lockResponse.ok || !cartResponse.ok) throw Object.assign(new Error('Current status unavailable'), {code:'CURRENT_STATUS_UNAVAILABLE'});
          const [live, cart] = await Promise.all([lockResponse.json(), cartResponse.json()]);
          const liveDate = Date.parse(lockResponse.headers.get('Date') || '');
          if (!['open','manual','scheduled'].includes(live.mode) || !Number.isFinite(live.releaseAt) || live.releaseAt < 0 || !Number.isFinite(live.serverNow) || live.serverNow <= 0 || !Array.isArray(cart.items) || cart.items.some(item => typeof item.key !== 'string' || typeof item.gift_card !== 'boolean')) throw Object.assign(new Error('Current status invalid'), {code:'CURRENT_STATUS_INVALID'});
          if (Number.isFinite(liveDate) && Math.abs(live.serverNow * 1000 - liveDate) > 5000) throw Object.assign(new Error('Current status stale'), {code:'CURRENT_STATUS_STALE'});
          Object.assign(next, live, {coralKeys:cart.items.filter(item => !item.gift_card).map(item => item.key)});
          serverDate = Number.isFinite(liveDate) ? liveDate : live.serverNow * 1000;
        }
        if (fresh && next.mode === 'open' && Number.isFinite(serverDate) && next.serverNow * 1000 < serverDate - 2000) {
          const stale = new Error('Stale open status');
          stale.code = 'STALE_LOCK_STATUS';
          throw stale;
        }
        if (version !== this.refreshVersion) return this.state;
        this.serverBase = Number.isFinite(serverDate) ? Math.max(serverDate, next.serverNow * 1000) : next.serverNow * 1000;
        this.clockBase = performance.now();
        this.state = next;
        this.dataset.effectiveMode = this.active() ? next.mode : 'open';
        this.dataset.checkedAt = String(next.serverNow);
        this.apply(doc);
        return this.state;
      };
      this.inflight = run().catch(error => {
        if (version !== this.refreshVersion) return this.state;
        if (error.code === 'STALE_LOCK_STATUS') return run();
        throw error;
      }).finally(() => { this.inflight = null; });
      return this.inflight;
    }
    refreshCheckoutStatus() {
      if (this.checkoutStatusPending) return this.checkoutStatusPending;
      const version = this.refreshVersion = (this.refreshVersion || 0) + 1;
      const run = async () => {
        const signal = AbortSignal.any([this.abort.signal, AbortSignal.timeout(20000)]);
        const [lockResponse, cartResponse] = await Promise.all([
          fetch(new URL('/lock', this.dataset.lockApi), {credentials:'omit', cache:'no-store', signal}),
          fetch(new URL(this.dataset.cartUrl + '.js', location.origin), {credentials:'same-origin', cache:'no-store', signal})
        ]);
        if (!lockResponse.ok || !cartResponse.ok) throw Object.assign(new Error('Current status unavailable'), {code:'CURRENT_STATUS_UNAVAILABLE'});
        const [live, cart] = await Promise.all([lockResponse.json(), cartResponse.json()]);
        const liveDate = Date.parse(lockResponse.headers.get('Date') || '');
        if (!['open','manual','scheduled'].includes(live.mode) || !Number.isFinite(live.releaseAt) || live.releaseAt < 0 || !Number.isFinite(live.serverNow) || live.serverNow <= 0 || !Array.isArray(cart.items) || cart.items.some(item => typeof item.key !== 'string' || typeof item.gift_card !== 'boolean')) throw Object.assign(new Error('Current status invalid'), {code:'CURRENT_STATUS_INVALID'});
        if (Number.isFinite(liveDate) && (Math.abs(live.serverNow * 1000 - liveDate) > 5000 || (live.mode === 'open' && live.serverNow * 1000 < liveDate - 2000))) throw Object.assign(new Error('Current status stale'), {code:'CURRENT_STATUS_STALE'});
        if (signal.aborted || version !== this.refreshVersion) throw new DOMException('Status check superseded', 'AbortError');
        this.state = {...this.state, ...live, coralKeys:cart.items.filter(item => !item.gift_card).map(item => item.key)};
        this.serverBase = Number.isFinite(liveDate) ? Math.max(liveDate, live.serverNow * 1000) : live.serverNow * 1000;
        this.clockBase = performance.now();
        this.dataset.effectiveMode = this.active() ? live.mode : 'open';
        this.dataset.checkedAt = String(live.serverNow);
        this.apply(document);
        return this.state;
      };
      const pending = run().finally(() => {
        if (this.checkoutStatusPending === pending) this.checkoutStatusPending = null;
      });
      this.checkoutStatusPending = pending;
      return pending;
    }
    apply(doc) {
      const active = this.active();
      const main = document.querySelector('#MainContent');
      if (this.dataset.scope === 'coral') {
        if (active) {
          const screen = main.querySelector('[data-sf-release-screen]');
          const target = Number(screen?.querySelector('[data-release-at]')?.dataset.releaseAt || 0);
          if (!screen || screen.dataset.releaseMode !== this.state.mode || target !== this.state.releaseAt) {
            const template = doc.querySelector('template[data-sf-lock-view]');
            if (template) {
              const hadFocus = main.contains(document.activeElement);
              document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
              main.replaceChildren(template.content.cloneNode(true));
              document.body.classList.add('sf-lock-page');
              if (hadFocus) { main.tabIndex = -1; main.focus(); }
              this.renderedLock = true;
            }
          }
          try { sessionStorage.removeItem('sf-lock-open-refresh'); } catch {}
        } else if (this.renderedLock) {
          this.reloadOnce('open:' + this.state.releaseAt);
        }
      }
      const blocked = active && this.state.coralKeys.length > 0;
      if (this.dataset.scope === 'cart' && this.cartBlocked !== blocked) this.reloadOnce('cart:' + blocked + ':' + this.state.releaseAt);
      this.cartBlocked = blocked;
      document.querySelectorAll('[name="checkout"], .additional-checkout-buttons, .shopify-payment-button').forEach(el => {
        const giftForm = el.closest('form')?.dataset.sfGiftCard === 'true';
        const shouldBlock = el.matches('.shopify-payment-button') ? active && !giftForm : blocked;
        if (shouldBlock) { el.setAttribute('data-sf-lock-disabled',''); el.inert = true; el.hidden = true; }
        else if (el.hasAttribute('data-sf-lock-disabled')) { el.removeAttribute('data-sf-lock-disabled'); el.inert = false; el.hidden = false; }
      });
      this.tick();
    }
    tick() {
      if (!this.state) return;
      const remaining = Math.max(0, Math.ceil((this.state.releaseAt * 1000 - this.now()) / 1000));
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      document.querySelectorAll('[data-sf-live-countdown]').forEach(clock => {
        clock.querySelectorAll('[data-time-unit]').forEach((digit,i) => { digit.textContent = String(values[i]).padStart(2,'0'); });
      });
      if (this.state.releaseAt > 0 && !remaining && this.zeroTarget !== this.state.releaseAt) {
        this.zeroTarget = this.state.releaseAt;
        this.apply(document);
        this.refresh().catch(() => { this.zeroTarget = null; });
      }
    }
    reloadOnce(key) {
      if (this.navigating) return;
      try {
        if (sessionStorage.getItem('sf-lock-open-refresh') === key) return;
        sessionStorage.setItem('sf-lock-open-refresh', key);
      } catch {}
      this.navigating = true;
      const url = new URL(location.href);
      url.searchParams.set('_sf_lock_refresh', String(Date.now()));
      location.replace(url.href);
    }
    error(form) {
      let node = form.querySelector('[data-sf-live-error]');
      if (!node) {
        node = document.createElement('p');
        node.className = 'sf-live-lock-error';
        node.dataset.sfLiveError = '';
        node.setAttribute('role','alert');
        form.append(node);
      }
      node.textContent = this.dataset.retryMessage;
    }
    consumeProductApproval(form) {
      const approval=this.productApprovals?.get(form);
      this.productApprovals?.delete(form);
      return Boolean(approval&&approval.version===this.refreshVersion&&performance.now()-approval.at<2000&&!this.active());
    }
    async guardSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.matches('[data-sf-remove-corals]')) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (this.busy.has(form)) return;
        this.busy.add(form);
        try {
          await this.refresh();
          const updates = Object.fromEntries(this.state.coralKeys.map(key => [key,0]));
          if (Object.keys(updates).length) {
            const response = await fetch(new URL(this.dataset.cartUrl + '/update.js', location.origin), {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates}),signal:this.abort.signal});
            if (!response.ok) throw new Error('Cart update failed');
          }
          location.assign(this.dataset.cartUrl);
        } catch { this.error(form); this.busy.delete(form); }
        return;
      }
      const add = /\/cart\/add(?:\.js)?$/.test(new URL(form.action).pathname);
      const checkout = event.submitter?.name === 'checkout';
      if (!add && !checkout) return;
      if (add && form.dataset.sfGiftCard === 'true') return;
      if (this.approved.has(form)) { this.approved.delete(form); return; }
      event.preventDefault(); event.stopImmediatePropagation();
      if (this.busy.has(form)) return;
      this.busy.add(form);
      const submitter = event.submitter;
      try {
        delete form.dataset.sfLockError;
        await this.refresh(true);
        const blocked = this.active() && (add ? form.dataset.sfGiftCard !== 'true' : this.state.coralKeys.length > 0);
        if (blocked) {
          if (checkout) location.assign(this.dataset.cartUrl);
          else if (this.dataset.scope !== 'coral') location.assign(this.dataset.root + 'collections');
          return;
        }
        if (!form.isConnected) return;
        this.approved.add(form);
        if(add){this.productApprovals||=new WeakMap();this.productApprovals.set(form,{version:this.refreshVersion,at:performance.now()});}
        form.requestSubmit(submitter?.isConnected ? submitter : undefined);
      } catch (error) { form.dataset.sfLockError = error?.code || error?.name || 'STATUS_UNKNOWN'; this.error(form); }
      finally { this.busy.delete(form); }
    }
    guardClick(event) {
      const target = event.target.closest('a[href], .shopify-payment-button, .additional-checkout-buttons');
      if (!target || !this.active()) return;
      const checkoutLink = target.tagName === 'A' && /\/checkout(?:s)?(?:\/|$)/.test(new URL(target.href, location.origin).pathname);
      const accelerated = target.matches('.shopify-payment-button, .additional-checkout-buttons');
      if ((checkoutLink && this.state.coralKeys.length) || (accelerated && (target.closest('form')?.dataset.sfGiftCard !== 'true') && (target.matches('.shopify-payment-button') || this.state.coralKeys.length))) {
        event.preventDefault(); event.stopImmediatePropagation();
        location.assign(this.dataset.cartUrl);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sf-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-countdown')) {
  customElements.define('sf-countdown', class extends HTMLElement {
    connectedCallback() {
      this.disconnectTimer();
      this.hidden = false;
      const raw = this.dataset.target || '';
      this.target = /(?:Z|[+-]\d{2}:?\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
      this.lastState = null;
      this.querySelector('[data-clock]')?.toggleAttribute('hidden', !Number.isFinite(this.target));
      this.tick();
      if (Number.isFinite(this.target) && this.target > Date.now()) this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { this.disconnectTimer(); }
    disconnectTimer() { if (this.timer) clearInterval(this.timer); this.timer = null; }
    tick() {
      if (!Number.isFinite(this.target)) {
        this.querySelector('[data-clock]')?.setAttribute('hidden','');
        this.setState('pending');
        return;
      }
      let seconds = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
      this.querySelectorAll('[data-time-unit]').forEach((node,i) => node.textContent = String(values[i]).padStart(2,'0'));
      this.setState(seconds > 0 ? 'before' : 'expired');
      if (!seconds) this.disconnectTimer();
    }
    setState(state) {
      if (state === this.lastState) return;
      this.lastState = state;
      this.dataset.state = state;
      this.querySelectorAll('[data-count-state]').forEach(el => el.hidden = el.dataset.countState !== state);
      const status = this.querySelector('[data-count-status]');
      if (status) status.textContent = this.dataset[state + 'Message'] || '';
      if (state === 'expired' && this.dataset.hideExpired === 'true' && this.dataset.lock !== 'true') this.hidden = true;
    }
  });
}
// Bound native requests through body decoding, and keep cancellation distinct from timeout.
async function sfNativeRequest(url, options, read) {
  const controller=new AbortController();let timer;
  const parent=options.signal;
  const abort=()=>controller.abort();
  if(parent?.aborted)controller.abort();else parent?.addEventListener('abort',abort,{once:true});
  try{return await Promise.race([
    fetch(url,{...options,signal:controller.signal}).then(async response=>({response,value:await response[read]()})),
    new Promise((_,reject)=>{timer=setTimeout(()=>{const error=new Error('CART_TIMEOUT');error.code='CART_TIMEOUT';reject(error);controller.abort();},12000);})
  ]);}finally{clearTimeout(timer);parent?.removeEventListener('abort',abort);}
}
if (!customElements.get('sf-product')) {
  customElements.define('sf-product', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      try { this.data = JSON.parse(this.querySelector('[data-product-json]').textContent); } catch { return; }
      this.variants = this.data.variants;
      this.select = this.querySelector('[data-variant-select]');
      this.track = this.querySelector('[data-thumb-track]');
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.activeId = String(this.select?.value || this.data.selected);
      this.viewingMother = this.dataset.viewingMother === 'true';
      this.submitting = false;
      const buy = this.querySelector('[data-add]');
      if (buy) { buy.hidden = this.viewingMother || !this.variants.some(v => v.available); buy.disabled = this.viewingMother || !this.variants.find(v => String(v.id) === this.activeId)?.available; buy.removeAttribute('aria-busy'); }
      if (this.select) {
        if (!this.select.hasAttribute('data-keep-visible')) {
          this.select.classList.add('sf-enhanced');
          this.select.tabIndex = -1;
          this.select.setAttribute('aria-hidden','true');
        }
        this.select.addEventListener('change', () => this.choose(this.select.value), {signal});
      }
      this.querySelectorAll('[data-variant-id]').forEach(button => button.addEventListener('click', () => this.choose(button.dataset.variantId), {signal}));
      this.querySelector('[data-mother-image]')?.addEventListener('click', () => this.showMother(), {signal});
      this.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => {
        this.track.scrollBy({left:this.track.clientWidth * Number(button.dataset.scroll),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal}));
      this.track?.addEventListener('scroll', () => this.updateArrows(), {signal,passive:true});
      this.resize = new ResizeObserver(() => this.updateArrows());
      if (this.track) this.resize.observe(this.track);
      this.updateArrows();
      this.querySelectorAll('[data-image-step]').forEach(button => button.addEventListener('click', () => {
        const buttons=[...this.querySelectorAll('[data-variant-id], [data-mother-image]')];
        const index=buttons.findIndex(item=>this.viewingMother ? item.hasAttribute('data-mother-image') : item.dataset.variantId===this.activeId);
        if(index>=0)buttons[index+Number(button.dataset.imageStep)]?.click();
      }, {signal}));
      this.updateImageArrows();
      const imageButton = this.querySelector('[data-open-lightbox]');
      const dialog = this.querySelector('dialog');
      imageButton?.addEventListener('click', () => {
        if (dialog && !dialog.open) { dialog.showModal(); this.querySelector('[data-close-dialog]')?.focus(); }
      }, {signal});
      this.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close(), {signal});
      dialog?.addEventListener('click', e => { if(e.target === dialog) dialog.close(); }, {signal});
      dialog?.addEventListener('close', () => imageButton.focus(), {signal});
      imageButton?.addEventListener('touchstart', e => { this.touchX=e.changedTouches[0].screenX; this.touchY=e.changedTouches[0].screenY; }, {signal,passive:true});
      imageButton?.addEventListener('touchend', e => {
        const dx=e.changedTouches[0].screenX-this.touchX,dy=e.changedTouches[0].screenY-this.touchY;
        if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)) {
          const buttons=[...this.querySelectorAll('[data-variant-id], [data-mother-image]')];
          const index=buttons.findIndex(b=>this.viewingMother ? b.hasAttribute('data-mother-image') : b.dataset.variantId===this.activeId);
          buttons[Math.max(0,Math.min(buttons.length-1,index+(dx<0?1:-1)))]?.click();
        }
      }, {signal,passive:true});
      this.form?.addEventListener('submit', event => this.addToCart(event), {signal});
      if(document.getElementById('SfPracticalConfig')&&this.form&&this.variants.some(v=>v.available)&&!this.form.querySelector('sf-frag-timer')){const timer=document.createElement('sf-frag-timer');timer.setAttribute('data-product','');(this.form.querySelector('[data-purchase-status-row]')||this.form).append(timer);}

      this.querySelectorAll('[role="tab"]').forEach(tab => {
        tab.addEventListener('click', () => this.openPanel(tab), {signal});
        tab.addEventListener('keydown', e => {
          const tabs=[...this.querySelectorAll('[role="tab"]')];let i=tabs.indexOf(tab);
          if(e.key==='ArrowRight')i=(i+1)%tabs.length;else if(e.key==='ArrowLeft')i=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')i=0;else if(e.key==='End')i=tabs.length-1;else return;
          e.preventDefault();this.openPanel(tabs[i]);tabs[i].focus();
        },{signal});
      });
    }
    disconnectedCallback() { this.abort?.abort();this.resize?.disconnect();this.resize=null;this.request?.abort();this.request=null;this.submitting=false; }
    updateArrows() {
      if(!this.track)return;
      const prev=this.querySelector('[data-scroll="-1"]'),next=this.querySelector('[data-scroll="1"]');
      if(prev)prev.disabled=this.track.scrollLeft<2;
      if(next)next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;
    }
    updateImageArrows() {
      const buttons=[...this.querySelectorAll('[data-variant-id], [data-mother-image]')];
      const index=buttons.findIndex(button=>this.viewingMother ? button.hasAttribute('data-mother-image') : button.dataset.variantId===this.activeId);
      this.querySelectorAll('[data-image-step]').forEach(button=>{
        const target=index+Number(button.dataset.imageStep);
        button.hidden=index<0||buttons.length<2||target<0||target>=buttons.length;
      });
    }
    showMother() {
      const button=this.querySelector('[data-mother-image]');if(!button)return;
      this.viewingMother=true;
      this.dataset.viewingMother='true';
      const buy=this.querySelector('[data-add]');
      if(buy){buy.hidden=true;buy.disabled=true;}
      this.querySelector('[data-photo-note]')?.setAttribute('hidden','');
      this.querySelector('[data-cart-add-confirmation]')?.setAttribute('hidden','');
      this.querySelector('[data-form-error]')?.setAttribute('hidden','');
      const img=this.querySelector('[data-main-image]');
      if(img){img.removeAttribute('srcset');img.src=button.dataset.motherImage;img.alt=this.data.title+' — '+button.getAttribute('aria-label');}
      const zoom=this.querySelector('[data-lightbox-image]');
      if(zoom){zoom.removeAttribute('srcset');zoom.src=button.dataset.motherZoom;zoom.alt=img?.alt||this.data.title;}
      this.querySelectorAll('[data-mother-label]').forEach(label=>label.hidden=false);
      this.querySelectorAll('[data-variant-id]').forEach(b=>b.setAttribute('aria-pressed','false'));
      button.setAttribute('aria-pressed','true');
      this.querySelector('[data-hero-caption]')?.setAttribute('hidden','');
      this.updateImageArrows();
    }
    choose(id) {
      const v=this.variants.find(v=>String(v.id)===String(id));if(!v||!v.available)return;
      this.viewingMother=false;
      this.dataset.viewingMother='false';
      this.querySelectorAll('[data-mother-label]').forEach(label=>label.hidden=true);
      this.querySelector('[data-mother-image]')?.setAttribute('aria-pressed','false');
      this.activeId=String(v.id);this.select.value=String(v.id);
      this.updateImageArrows();
      this.querySelectorAll('[data-variant-id]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variantId===this.activeId)));
      const active=this.querySelector('[data-variant-id="'+this.activeId+'"]');
      if(active&&this.track){const left=active.offsetLeft-this.track.firstElementChild.offsetLeft;if(left<this.track.scrollLeft)this.track.scrollLeft=left;else if(left+active.offsetWidth>this.track.scrollLeft+this.track.clientWidth)this.track.scrollLeft=left+active.offsetWidth-this.track.clientWidth;}
      const img=this.querySelector('[data-main-image]');if(img&&v.image){img.src=v.image;img.removeAttribute('srcset');img.alt=v.alt||this.data.title;}
      const zoom=this.querySelector('[data-lightbox-image]');if(zoom&&v.zoom){zoom.removeAttribute('srcset');zoom.src=v.zoom;zoom.alt=v.alt||this.data.title;}
      this.querySelector('[data-hero-caption]')?.setAttribute('hidden','');
      const photoNote=this.querySelector('[data-photo-note]');if(photoNote){photoNote.hidden=false;if(v.photoNote)photoNote.textContent=v.photoNote;}
      const photoExactHeading=this.querySelector('[data-photo-exact-heading]');if(photoExactHeading)photoExactHeading.hidden=!v.photoExact;
      const price=this.querySelector('[data-price]');if(price)price.textContent=v.money;
      const stock=this.querySelector('[data-stock]');if(stock){stock.dataset.available=String(v.available);stock.textContent=v.available?this.data.labels.inStock:this.data.labels.outOfStock;}
      const anyAvailable=this.variants.some(v=>v.available);
      const buy=this.querySelector('[data-add]'),notify=this.querySelector('[data-notify]');
      if(buy){buy.hidden=!anyAvailable;buy.disabled=!v.available||Boolean(this.submitting);buy.querySelector('[data-add-label]').textContent=this.submitting?this.data.labels.adding:(v.available?this.data.labels.add:this.data.labels.outOfStock);}
      if(notify)notify.hidden=anyAvailable;
      const helper=this.querySelector('[data-mixed-helper]');if(helper)helper.hidden=v.available||!anyAvailable;
      this.querySelector('[data-notify-note]')?.setAttribute('hidden','');
      const error=this.querySelector('[data-form-error]');if(error){error.textContent='';error.hidden=true;}
      const confirmation=this.querySelector('[data-cart-add-confirmation]');
      if(confirmation){confirmation.hidden=true;confirmation.textContent='';}
      const url=new URL(location.href);url.searchParams.set('variant',String(v.id));history.replaceState({},'',url);
      this.dispatchEvent(new CustomEvent('signature-frags:variant-change',{bubbles:true,detail:{productId:this.data.id,variant:v}}));
    }
    openPanel(tab) {
      this.querySelectorAll('[role="tab"]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
      this.querySelectorAll('[role="tabpanel"]').forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'));
    }
    confirmAdded(variant,result,itemCount) {
      const buy=this.querySelector('[data-add]');
      let confirmation=this.querySelector('[data-cart-add-confirmation]');
      if(!confirmation){confirmation=document.createElement('p');confirmation.dataset.cartAddConfirmation='';confirmation.className='sf-helper';confirmation.setAttribute('role','status');buy.after(confirmation);}
      confirmation.hidden=this.viewingMother;confirmation.textContent=this.data.title+' — '+this.data.labels.added;
      this.dispatchEvent(new CustomEvent('signature-frags:cart-add',{bubbles:true,detail:{productId:this.data.id,variantId:variant.id,item:result,cartUrl:this.dataset.cartUrl,itemCount}}));
    }
    async addToCart(event) {
      if(this.viewingMother||this.dataset.viewingMother==='true'){event.preventDefault();return;}
      if(this.submitting){event.preventDefault();return;}
      const variant=this.variants.find(v=>String(v.id)===this.activeId);
      if(!variant?.available){event.preventDefault();return;}
      event.preventDefault();
      const buy=this.querySelector('[data-add]'),error=this.querySelector('[data-form-error]');
      this.submitting=true;buy.disabled=true;buy.setAttribute('aria-busy','true');buy.querySelector('[data-add-label]').textContent=this.data.labels.adding;
      if(error){error.hidden=true;error.textContent='';}
      const confirmation=this.querySelector('[data-cart-add-confirmation]');
      if(confirmation){confirmation.hidden=true;confirmation.textContent='';}
      this.request?.abort();const request=new AbortController();this.request=request;
      const data=new FormData(this.form);
      if(this.data.singleQuantity || this.data.wysiwyg)data.set('quantity','1');
      let pending;
      const intentKey='sf-pending-add:'+this.data.id;
      const saveIntent=value=>{this.pendingAdd=value;try{if(value)sessionStorage.setItem(intentKey,JSON.stringify(value));else sessionStorage.removeItem(intentKey);}catch{}};
      const freshBasket=async()=>{const {response,value}=await sfNativeRequest(this.dataset.cartUrl+'.js',{credentials:'same-origin',cache:'no-store',signal:request.signal},'json');if(!response.ok||!Array.isArray(value.items))throw new Error(this.data.labels.cartError);return value;};
      const quantityIn=(basket,id)=>basket.items.filter(item=>String(item.variant_id)===String(id)).reduce((sum,item)=>sum+Number(item.quantity),0);
      try {
        try{pending=this.pendingAdd||JSON.parse(sessionStorage.getItem(intentKey)||'null');}catch{}
        if(pending){
          const current=await freshBasket();
          if(quantityIn(current,pending.variantId)>=pending.target){saveIntent(null);this.confirmAdded({id:pending.variantId},current,current.item_count);return;}
          // A customer can explicitly retry only after reviewing the basket.
          if(!pending.reviewed)throw new Error('CART_UNCERTAIN');
          saveIntent(null);pending=null;
        }
        const gate=document.querySelector('sf-live-lock');
        if(gate&&this.form.dataset.sfGiftCard!=='true'){await customElements.whenDefined('sf-live-lock');if(!gate.consumeProductApproval?.(this.form))await gate.refresh(true);if(gate.active())return;}
        // The custom product form must check stock independently of reservation scope.
        const stockUrl=new URL(this.dataset.productUrl,location.origin);
        stockUrl.searchParams.set('section_id',this.dataset.sectionId);
        stockUrl.searchParams.set('variant',String(variant.id));
        const stockRequest=sfNativeRequest(stockUrl,{credentials:'same-origin',cache:'no-store',signal:request.signal},'text');
        // Readiness can be delayed; retain the rejection until the stock guard awaits it.
        stockRequest.catch(()=>{});
        let basket,already,quantity;
        const validateBasket=async current=>{
          const stockResult=await stockRequest;
          if(!stockResult.response.ok)throw new Error(this.data.labels.cartError);
          const stockDocument=new DOMParser().parseFromString(stockResult.value,'text/html');
          const stockData=JSON.parse(stockDocument.querySelector('[data-product-json]')?.textContent||'null');
          const stock=stockData?.variants?.find(v=>String(v.id)===String(variant.id));
          if(!Array.isArray(current.items)||!stock||!Number.isSafeInteger(stock.inventoryQuantity))throw new Error('Unable to check stock. Please refresh and try again.');
          quantity=Number(data.get('quantity')||1);
          if(!Number.isSafeInteger(quantity)||quantity<1)throw new Error('Please choose a valid quantity.');
          already=current.items.filter(item=>String(item.variant_id)===String(variant.id)).reduce((total,item)=>total+Number(item.quantity),0);
          const maximum=stock.inventoryManagement&&stock.inventoryPolicy==='deny'?Math.max(0,stock.inventoryQuantity):Infinity;
          if(!stock.available||already+quantity>maximum){
            if(maximum===1&&already>=1)throw new Error('This coral is already in your basket.');
            throw new Error(Number.isFinite(maximum)?`Only ${maximum} of this variant can be added to your basket.`:this.data.labels.outOfStock);
          }
          if(!this.isConnected||request.signal.aborted)throw new DOMException('Cancelled','AbortError');
          basket=current;
        };
        if(document.getElementById('SfPracticalConfig')){
          await Promise.race([customElements.whenDefined('sf-frag-timer'),new Promise((_,reject)=>setTimeout(()=>reject(new Error(JSON.parse(document.getElementById('SfPracticalConfig').textContent).copy.reservation_unavailable)),12000))]);
          const practical=window.SignatureFragsPractical;
          if(typeof practical.beforeCheckedAdd==='function')await practical.beforeCheckedAdd(data,validateBasket);
          else{await validateBasket(await freshBasket());await practical.beforeAdd(data);}
        }else await validateBasket(await freshBasket());
        if(!this.isConnected||request.signal.aborted)return;
        pending={variantId:variant.id,target:already+quantity,reviewed:false};saveIntent(pending);
        let added;
        try{added=await sfNativeRequest(this.form.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json'},signal:request.signal},'json');if(added.response.status>=500)throw new Error('CART_UNCERTAIN');}
        catch(failure){
          // An accepted write can lose its response. Read back once; never resend it.
          try{const current=await freshBasket();if(quantityIn(current,variant.id)>=pending.target){saveIntent(null);this.confirmAdded(variant,current,current.item_count);return;}}catch{}
          throw new Error('CART_UNCERTAIN');
        }
        saveIntent(null);
        if(!added.response.ok)throw new Error(added.value.description||added.value.message||this.data.labels.cartError);
        this.confirmAdded(variant,added.value,basket.item_count+quantity);
      } catch(e) {
        if(e.name!=='AbortError'&&error){
          error.textContent=e.message==='CART_TIMEOUT'?(this.data.labels.cartTimeout||this.data.labels.cartError):e.message==='CART_UNCERTAIN'?(this.data.labels.cartUncertain||this.data.labels.cartError):e.message;
          if(e.message==='CART_UNCERTAIN'){const link=document.createElement('a');link.href=this.dataset.cartUrl;link.textContent=this.data.labels.viewBasket||this.data.labels.cartError;link.addEventListener('click',()=>{if(pending)saveIntent({...pending,reviewed:true});},{once:true});error.append(' ',link);}
          error.hidden=false;
        }
      } finally {if(data.get('properties[_sf_reservation_id]'))window.SignatureFragsPractical?.completeAdd(variant.id);if(this.request===request){this.request=null;this.submitting=false;const current=this.variants.find(v=>String(v.id)===this.activeId);buy.hidden=this.viewingMother||!this.variants.some(v=>v.available);buy.disabled=this.viewingMother||!current?.available;buy.removeAttribute('aria-busy');buy.querySelector('[data-add-label]').textContent=current?.available?this.data.labels.add:this.data.labels.outOfStock;}}
    }
  });
}
if (!customElements.get('sf-recommendations')) {
 customElements.define('sf-recommendations',class extends HTMLElement {
   connectedCallback(){this.disconnectedCallback();this.bindCarousel();if(this.dataset.loaded==='true')return;this.controller=new AbortController();this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'300px'});this.observer.observe(this);}
   disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.carouselAbort?.abort();this.carouselResize?.disconnect();}
   bindCarousel(){
    this.carouselAbort?.abort();this.carouselResize?.disconnect();
    this.carouselAbort=new AbortController();const signal=this.carouselAbort.signal;
    const track=this.querySelector('[data-related-track]');if(!track)return;
    const prev=this.querySelector('[data-related-scroll="-1"]'),next=this.querySelector('[data-related-scroll="1"]');
    const update=()=>{const overflow=track.scrollWidth>track.clientWidth+2;this.querySelector('[data-related-controls]')?.toggleAttribute('hidden',!overflow);if(prev)prev.disabled=track.scrollLeft<2;if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
    const move=direction=>track.scrollBy({left:direction*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    prev?.addEventListener('click',()=>move(-1),{signal});next?.addEventListener('click',()=>move(1),{signal});
    track.addEventListener('scroll',update,{signal,passive:true});
    track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}else if(e.key==='Home'||e.key==='End'){e.preventDefault();track.scrollTo({left:e.key==='Home'?0:track.scrollWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}},{signal});
    this.carouselResize=new ResizeObserver(update);this.carouselResize.observe(track);update();
   }
   async load(){
    if(!this.dataset.url)return;
    try{const response=await fetch(this.dataset.url,{signal:this.controller.signal});if(!response.ok)return;const html=await response.text();const doc=new DOMParser().parseFromString(html,'text/html');const content=doc.querySelector('sf-recommendations [data-recommendation-content]');if(content&&content.children.length){this.querySelector('[data-recommendation-content]').replaceChildren(...content.cloneNode(true).childNodes);this.hidden=false;this.bindCarousel();}this.dataset.loaded='true';}catch(e){if(e.name!=='AbortError')this.dataset.loaded='fallback';}
   }
 });
}
const sfLifecycleSelector = 'sf-countdown, sf-product, sf-recommendations';
const sfSectionComponents = target => [
  ...(target.matches?.(sfLifecycleSelector) ? [target] : []),
  ...target.querySelectorAll(sfLifecycleSelector)
];
document.addEventListener('shopify:section:unload', event => {
  sfSectionComponents(event.target).forEach(component => component.disconnectedCallback?.());
});
document.addEventListener('shopify:section:load', event => {
  sfSectionComponents(event.target).forEach(component => component.connectedCallback?.());
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.sf-header details[open]');
  if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); event.preventDefault(); }
});
const sfRenderCartCount = count => {
  if (!Number.isFinite(count) || count < 0) return;
  document.querySelectorAll('.sf-cart-count').forEach(node => { node.textContent = String(count); });
};
let sfCartCountRequest = 0;
document.addEventListener('signature-frags:cart-add', event => {
  const request = ++sfCartCountRequest;
  sfRenderCartCount(event.detail?.itemCount);
  const url = event.detail?.cartUrl;
  if (!url) return;
  fetch(url + '.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
    .then(response => response.ok ? response.json() : null)
    .then(cart => { if (cart && request === sfCartCountRequest) sfRenderCartCount(cart.item_count); })
    .catch(() => {});
});
document.addEventListener('shopify:cart:lines-update', event => {
  event.promise?.then(({ cart, detail }) => sfRenderCartCount(cart?.totalQuantity ?? detail?.itemCount)).catch(() => {});
});
window.addEventListener('pageshow', event => {
  if (!event.persisted) return;
  const url = document.querySelector('[data-sf-cart-url]')?.dataset.sfCartUrl;
  if (url) fetch(url + '.js', {headers:{Accept:'application/json'}}).then(response => response.ok ? response.json() : null).then(cart => { if (cart) sfRenderCartCount(cart.item_count); }).catch(() => {});
});
  } catch(e) { console.error(e); }
})();

})();
